const { hostname } = window.location;

function getEnvVars() {
  if (hostname === 'teachers.ace.online') {
    return buildProdEnvVars();
  }
  if (hostname === 'teachers-pre-prod.ace.online') {
    return buildPreProdEnvVars();
  }
  if (hostname === 'teachers-staging.ace.online') {
    return buildStagingEnvVars();
  }
  if (hostname === 'teachers-test.ace.online') {
    return buildTestEnvVars();
  }
  if (hostname === 'teachers-dev.ace.online') {
    return buildDevEnvVars();
  }
  return buildLocalEnvVars();
}

function buildProdEnvVars() {
  return {
    //TODO: make sure the production value is 'prod' or 'production'
    ENV: 'prod',

    rsaPublicKey:
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCV0OeWTL5k1PdtC0YBlXLsoqChOvrI3X4A5/pvmmQGL+KkIPHbzKFy3TWrwTuyn9ghEz2JHrjkdCGsCnlLFm1XQp7TRrR7xkIA6FmXfsc+eaIfBJh0sj/Onsy9v0aqUdH6evoRbb/gWqJGYXRRcPSKIZOEInGvUpQLfRSPy0kqhQIDAQAB',
    hmacSecretKey: 'deep-learn-web-H46VCkVJZOyg',
    s3BucketFileExplore: 'deep-learn-vod-source-1pgk1xt548iii',
    s3BucketPublisher: 'deep-learn-internal-resources',
    s3BucketPreviewVideos: 'deep-learn-vod-source-1pgk1xt548iii',
    s3BucketLegal: 'deep-learn-internal-resources',
    s3BucketInstructor: 'deep-learn-internal-resources',
    s3BucketThumbnail: 'deep-learn-vod-destination-1lpke2l3cwme9',
    s3BucketTestimonial: 'deep-learn-internal-resources',
    s3BucketSyllabus: 'deep-learn-internal-resources',
    s3BucketStoreIcon: 'deep-learn-internal-resources',
    s3BucketQuestionPaper: 'deep-learn-internal-resources',
    s3BucketCatalogueImage: 'deep-learn-internal-resources',
    s3BucketLiveCLassResources: 'deep-learn-internal-resources',

    s3PathLiveClassNotes: 'live-classes/notes/',
    s3PathLiveClassAssignments: 'live-classes/assignments/',
    s3PathLiveClassPracticeTests: 'live-classes/practice-test/',
    s3PathLiveClassThumbnails: 'live-classes/thumbnails/{uuid-filename}',

    s3PathImage: '[module]/images/',
    s3PathResource: '[module]/resources/',
    s3PathPreviewVideos: 'preview-videos/[catalogueId]/',
    s3PathLegalFile: 'terms_and_conditions/{uuid-filename}',
    s3PathInstructorImage: 'instructors/images/{uuid-filename}',
    s3PathInstructorResume: 'instructors/resumes/{uuid-filename}',
    s3PathTestimonialImage: 'store-listing/testimonials/{uuid-filename}',
    s3PathThumbnail: 'preview-videos/{catalogueId}/{videoId}/thumbnail/',
    s3PathSyllabus: 'catalogues/syllabus/{uuid-filename}',
    s3PathStoreIcon: 'catalogues/store-icon/{uuid-filename}',
    s3PathQuestionPaper: 'catalogues/question-paper/{uuid-filename}',
    s3PathCatalogueImage: 'catalogues/images/{uuid-filename}',

    s3MaxKeys: 50,
    // Transcoding
    transcodingEnvironment: 'production',
    transcodingSourceS3: 'deep-learn-vod-source-1pgk1xt548iii',
    transcodingDestinationS3: 'deep-learn-vod-destination-1lpke2l3cwme9',

    // s3PathDynamic : "image/[path]/folder"
    cloudFrontUrlCatalogueResource: 'https://media-ir.ace.online',
    s3ResourceUrl: 'https://{bucketName}.s3.ap-south-1.amazonaws.com/{path}',

    cloudFrontUrl: 'https://media-ir.ace.online',
    previewVideoCloudfrontUrl: 'https://cdn-vod.deep-learn.in',
    previewVideoHlsUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/index.m3u8',
    previewVideodashUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/manifest.mpd',

    cloudFrontUrlTnc: 'https://media-ir.ace.online',
    tncFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlInstructor: 'https://media-ir.ace.online',
    InstructorImageFileUrl: '{cloudFrontUrl}/{file-path}',
    InstructorResumeFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlTestimonial: 'https://media-ir.ace.online',
    TestimonialFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlThumbnail: 'https://d3ble58c9xsklv.cloudfront.net',
    thumbnailFolderUrl: '{cloudFrontUrl}/transcoding_version_3/preview-videos/{videoId}/thumbnails',

    cloudFrounUrlSyllabus: 'https://media-ir.ace.online',
    syllabusFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlStoreIcon: 'https://media-ir.ace.online',
    storeIconFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlQuestionPaper: 'https://media-ir.ace.online',
    questionPaperFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlCatalogueImage: 'https://media-ir.ace.online',
    catalogueImageFileUrl: '{cloudFrontUrl}/{file-path}',
    /// Bulk upload students sample resource link
    bulkUploadStudentXlxSampleFileLink:
      'https://media-ir.ace.online/live-classes/bulk_upload_sample_template.xlsx',
  };
}

function buildStagingEnvVars() {
  return {
    ENV: 'staging',

    rsaPublicKey:
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCA33d/ObvH5A+UkxrtoAI5MmC4R0saRRomrbnVPZj2oDSeCUgQL3WKDb/xxwbRVu+ZIcbLBWal3aoLH9W6TKTHbZY6czkTHaT1RzeWX7nWwiwuZOVIc7gdH6ty+u+p00XTI0Rnme7dNlRF/8f92JQ045sqqSxb78pOYzCQZFxdhQIDAQAB',
    hmacSecretKey: 'C6PqJwbyW4',
    s3BucketFileExplore: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketPublisher: 'deep-learn-internal-resources-test',
    s3BucketPreviewVideos: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketLegal: 'deep-learn-internal-resources-test',
    s3BucketInstructor: 'deep-learn-internal-resources-test',
    s3BucketThumbnail: 'deep-learn-vod-test-destination-1k6b102sisn5o',
    s3BucketTestimonial: 'deep-learn-internal-resources-test',
    s3BucketSyllabus: 'deep-learn-internal-resources-test',
    s3BucketStoreIcon: 'deep-learn-internal-resources-test',
    s3BucketQuestionPaper: 'deep-learn-internal-resources-test',
    s3BucketCatalogueImage: 'deep-learn-internal-resources-test',
    s3BucketLiveCLassResources: 'deep-learn-internal-resources-test',

    s3PathLiveClassNotes: 'live-classes/notes/',
    s3PathLiveClassAssignments: 'live-classes/assignments/',
    s3PathLiveClassPracticeTests: 'live-classes/practice-test/',
    s3PathLiveClassThumbnails: 'live-classes/thumbnails/{uuid-filename}',

    s3PathImage: '[module]/images/',
    s3PathResource: '[module]/resources/',
    s3PathPreviewVideos: 'preview-videos/[catalogueId]/',
    s3PathLegalFile: 'terms_and_conditions/{uuid-filename}',
    s3PathInstructorImage: 'instructors/images/{uuid-filename}',
    s3PathInstructorResume: 'instructors/resumes/{uuid-filename}',
    s3PathTestimonialImage: 'store-listing/testimonials/{uuid-filename}',
    s3PathThumbnail: 'preview-videos/{catalogueId}/{videoId}/thumbnail/',
    s3PathSyllabus: 'catalogues/syllabus/{uuid-filename}',
    s3PathStoreIcon: 'catalogues/store-icon/{uuid-filename}',
    s3PathQuestionPaper: 'catalogues/question-paper/{uuid-filename}',
    s3PathCatalogueImage: 'catalogues/images/{uuid-filename}',

    s3MaxKeys: 50,
    // Transcoding
    transcodingEnvironment: 'staging',
    transcodingSourceS3: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    transcodingDestinationS3: 'deep-learn-vod-test-destination-1k6b102sisn5o',

    // s3PathDynamic : "image/[path]/folder"
    cloudFrontUrlCatalogueResource: 'https://media-ir-test.ace.online',
    s3ResourceUrl: 'https://{bucketName}.s3.ap-south-1.amazonaws.com/{path}',

    cloudFrontUrl: 'https://media-ir-test.ace.online',
    previewVideoCloudfrontUrl: 'https://cdn-vod.deep-learn.in',
    previewVideoHlsUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/index.m3u8',
    previewVideodashUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/manifest.mpd',

    cloudFrontUrlTnc: 'https://media-ir-test.ace.online',
    tncFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlInstructor: 'https://media-ir-test.ace.online',
    InstructorImageFileUrl: '{cloudFrontUrl}/{file-path}',
    InstructorResumeFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlTestimonial: 'https://media-ir-test.ace.online',
    TestimonialFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlThumbnail: 'https://d2gd7uae3xw47.cloudfront.net',
    thumbnailFolderUrl: '{cloudFrontUrl}/transcoding_version_3/preview-videos/{videoId}/thumbnails',

    cloudFrounUrlSyllabus: 'https://media-ir-test.ace.online',
    syllabusFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlStoreIcon: 'https://media-ir-test.ace.online',
    storeIconFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlQuestionPaper: 'https://media-ir-test.ace.online',
    questionPaperFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlCatalogueImage: 'https://media-ir-test.ace.online',
    catalogueImageFileUrl: '{cloudFrontUrl}/{file-path}',
    /// Bulk upload students sample resource link
    bulkUploadStudentXlxSampleFileLink:
      'https://media-ir-test.ace.online/live-classes/bulk_upload_sample_template.xlsx',
  };
}
function buildPreProdEnvVars() {
  return {
    //TODO: make sure the production value is 'prod' or 'production'
    ENV: 'preProd',
    rsaPublicKey:
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCA33d/ObvH5A+UkxrtoAI5MmC4R0saRRomrbnVPZj2oDSeCUgQL3WKDb/xxwbRVu+ZIcbLBWal3aoLH9W6TKTHbZY6czkTHaT1RzeWX7nWwiwuZOVIc7gdH6ty+u+p00XTI0Rnme7dNlRF/8f92JQ045sqqSxb78pOYzCQZFxdhQIDAQAB',
    hmacSecretKey: 'C6PqJwbyW4',
    s3BucketFileExplore: 'deep-learn-vod-source-1pgk1xt548iii',
    s3BucketPublisher: 'deep-learn-internal-resources',
    s3BucketPreviewVideos: 'deep-learn-vod-source-1pgk1xt548iii',
    s3BucketLegal: 'deep-learn-internal-resources',
    s3BucketInstructor: 'deep-learn-internal-resources',
    s3BucketThumbnail: 'deep-learn-vod-destination-1lpke2l3cwme9',
    s3BucketTestimonial: 'deep-learn-internal-resources',
    s3BucketSyllabus: 'deep-learn-internal-resources',
    s3BucketStoreIcon: 'deep-learn-internal-resources',
    s3BucketQuestionPaper: 'deep-learn-internal-resources',
    s3BucketCatalogueImage: 'deep-learn-internal-resources',
    s3BucketLiveCLassResources: 'deep-learn-internal-resources',

    s3PathLiveClassNotes: 'live-classes/notes/',
    s3PathLiveClassAssignments: 'live-classes/assignments/',
    s3PathLiveClassPracticeTests: 'live-classes/practice-test/',
    s3PathLiveClassThumbnails: 'live-classes/thumbnails/{uuid-filename}',

    s3PathImage: '[module]/images/',
    s3PathResource: '[module]/resources/',
    s3PathPreviewVideos: 'preview-videos/[catalogueId]/',
    s3PathLegalFile: 'terms_and_conditions/{uuid-filename}',
    s3PathInstructorImage: 'instructors/images/{uuid-filename}',
    s3PathInstructorResume: 'instructors/resumes/{uuid-filename}',
    s3PathTestimonialImage: 'store-listing/testimonials/{uuid-filename}',
    s3PathThumbnail: 'preview-videos/{catalogueId}/{videoId}/thumbnail/',
    s3PathSyllabus: 'catalogues/syllabus/{uuid-filename}',
    s3PathStoreIcon: 'catalogues/store-icon/{uuid-filename}',
    s3PathQuestionPaper: 'catalogues/question-paper/{uuid-filename}',
    s3PathCatalogueImage: 'catalogues/images/{uuid-filename}',

    s3MaxKeys: 50,
    // Transcoding
    transcodingEnvironment: 'production',
    transcodingSourceS3: 'deep-learn-vod-source-1pgk1xt548iii',
    transcodingDestinationS3: 'deep-learn-vod-destination-1lpke2l3cwme9',

    // s3PathDynamic : "image/[path]/folder"
    cloudFrontUrlCatalogueResource: 'https://media-ir.ace.online',
    s3ResourceUrl: 'https://{bucketName}.s3.ap-south-1.amazonaws.com/{path}',

    cloudFrontUrl: 'https://media-ir.ace.online',
    previewVideoCloudfrontUrl: 'https://cdn-vod.deep-learn.in',
    previewVideoHlsUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/index.m3u8',
    previewVideodashUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/manifest.mpd',

    cloudFrontUrlTnc: 'https://media-ir.ace.online',
    tncFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlInstructor: 'https://media-ir.ace.online',
    InstructorImageFileUrl: '{cloudFrontUrl}/{file-path}',
    InstructorResumeFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlTestimonial: 'https://media-ir.ace.online',
    TestimonialFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlThumbnail: 'https://d3ble58c9xsklv.cloudfront.net',
    thumbnailFolderUrl: '{cloudFrontUrl}/transcoding_version_3/preview-videos/{videoId}/thumbnails',

    cloudFrounUrlSyllabus: 'https://media-ir.ace.online',
    syllabusFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlStoreIcon: 'https://media-ir.ace.online',
    storeIconFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlQuestionPaper: 'https://media-ir.ace.online',
    questionPaperFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlCatalogueImage: 'https://media-ir.ace.online',
    catalogueImageFileUrl: '{cloudFrontUrl}/{file-path}',
    /// Bulk upload students sample resource link
    bulkUploadStudentXlxSampleFileLink:
      'https://media-ir.ace.online/live-classes/bulk_upload_sample_template.xlsx',
  };
}
function buildTestEnvVars() {
  return {
    ENV: 'test',

    rsaPublicKey:
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCA33d/ObvH5A+UkxrtoAI5MmC4R0saRRomrbnVPZj2oDSeCUgQL3WKDb/xxwbRVu+ZIcbLBWal3aoLH9W6TKTHbZY6czkTHaT1RzeWX7nWwiwuZOVIc7gdH6ty+u+p00XTI0Rnme7dNlRF/8f92JQ045sqqSxb78pOYzCQZFxdhQIDAQAB',
    hmacSecretKey: 'C6PqJwbyW4',
    s3BucketFileExplore: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketPublisher: 'deep-learn-internal-resources-test',
    s3BucketPreviewVideos: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketLegal: 'deep-learn-internal-resources-test',
    s3BucketInstructor: 'deep-learn-internal-resources-test',
    s3BucketThumbnail: 'deep-learn-vod-test-destination-1k6b102sisn5o',
    s3BucketTestimonial: 'deep-learn-internal-resources-test',
    s3BucketSyllabus: 'deep-learn-internal-resources-test',
    s3BucketStoreIcon: 'deep-learn-internal-resources-test',
    s3BucketQuestionPaper: 'deep-learn-internal-resources-test',
    s3BucketCatalogueImage: 'deep-learn-internal-resources-test',
    s3BucketLiveCLassResources: 'deep-learn-internal-resources-test',

    s3PathLiveClassNotes: 'live-classes/notes/',
    s3PathLiveClassAssignments: 'live-classes/assignments/',
    s3PathLiveClassPracticeTests: 'live-classes/practice-test/',
    s3PathLiveClassThumbnails: 'live-classes/thumbnails/{uuid-filename}',

    s3PathImage: '[module]/images/',
    s3PathResource: '[module]/resources/',
    s3PathPreviewVideos: 'preview-videos/[catalogueId]/',
    s3PathLegalFile: 'terms_and_conditions/{uuid-filename}',
    s3PathInstructorImage: 'instructors/images/{uuid-filename}',
    s3PathInstructorResume: 'instructors/resumes/{uuid-filename}',
    s3PathTestimonialImage: 'store-listing/testimonials/{uuid-filename}',
    s3PathThumbnail: 'preview-videos/{catalogueId}/{videoId}/thumbnail/',
    s3PathSyllabus: 'catalogues/syllabus/{uuid-filename}',
    s3PathStoreIcon: 'catalogues/store-icon/{uuid-filename}',
    s3PathQuestionPaper: 'catalogues/question-paper/{uuid-filename}',
    s3PathCatalogueImage: 'catalogues/images/{uuid-filename}',

    s3MaxKeys: 50,
    // Transcoding
    transcodingEnvironment: 'test',
    transcodingSourceS3: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    transcodingDestinationS3: 'deep-learn-vod-test-destination-1k6b102sisn5o',
    // s3PathDynamic : "image/[path]/folder"
    cloudFrontUrlCatalogueResource: 'https://media-ir-test.ace.online',
    s3ResourceUrl: 'https://{bucketName}.s3.ap-south-1.amazonaws.com/{path}',

    cloudFrontUrl: 'https://media-ir-test.ace.online',
    previewVideoCloudfrontUrl: 'https://cdn-vod.deep-learn.in',
    previewVideoHlsUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/index.m3u8',
    previewVideodashUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/manifest.mpd',

    cloudFrontUrlTnc: 'https://media-ir-test.ace.online',
    tncFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlInstructor: 'https://media-ir-test.ace.online',
    InstructorImageFileUrl: '{cloudFrontUrl}/{file-path}',
    InstructorResumeFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlTestimonial: 'https://media-ir-test.ace.online',
    TestimonialFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlThumbnail: 'https://d2gd7uae3xw47.cloudfront.net',
    thumbnailFolderUrl: '{cloudFrontUrl}/transcoding_version_3/preview-videos/{videoId}/thumbnails',

    cloudFrounUrlSyllabus: 'https://media-ir-test.ace.online',
    syllabusFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlStoreIcon: 'https://media-ir-test.ace.online',
    storeIconFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlQuestionPaper: 'https://media-ir-test.ace.online',
    questionPaperFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlCatalogueImage: 'https://media-ir-test.ace.online',
    catalogueImageFileUrl: '{cloudFrontUrl}/{file-path}',
    /// Bulk upload students sample resource link
    bulkUploadStudentXlxSampleFileLink:
      'https://media-ir-test.ace.online/live-classes/bulk_upload_sample_template.xlsx',
  };
}

function buildLocalEnvVars() {
  return {
    ENV: 'local',

    rsaPublicKey:
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCA33d/ObvH5A+UkxrtoAI5MmC4R0saRRomrbnVPZj2oDSeCUgQL3WKDb/xxwbRVu+ZIcbLBWal3aoLH9W6TKTHbZY6czkTHaT1RzeWX7nWwiwuZOVIc7gdH6ty+u+p00XTI0Rnme7dNlRF/8f92JQ045sqqSxb78pOYzCQZFxdhQIDAQAB',
    hmacSecretKey: 'C6PqJwbyW4',
    s3BucketFileExplore: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketPublisher: 'deep-learn-internal-resources-test',
    s3BucketPreviewVideos: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketLegal: 'deep-learn-internal-resources-test',
    s3BucketInstructor: 'deep-learn-internal-resources-test',
    s3BucketThumbnail: 'deep-learn-vod-test-destination-1k6b102sisn5o',
    s3BucketTestimonial: 'deep-learn-internal-resources-test',
    s3BucketSyllabus: 'deep-learn-internal-resources-test',
    s3BucketStoreIcon: 'deep-learn-internal-resources-test',
    s3BucketQuestionPaper: 'deep-learn-internal-resources-test',
    s3BucketCatalogueImage: 'deep-learn-internal-resources-test',
    s3BucketLiveCLassResources: 'deep-learn-internal-resources-test',

    s3PathLiveClassNotes: 'live-classes/notes/',
    s3PathLiveClassAssignments: 'live-classes/assignments/',
    s3PathLiveClassPracticeTests: 'live-classes/practice-test/',
    s3PathLiveClassThumbnails: 'live-classes/thumbnails/{uuid-filename}',

    s3PathImage: '[module]/images/',
    s3PathResource: '[module]/resources/',
    s3PathPreviewVideos: 'preview-videos/[catalogueId]/',
    s3PathLegalFile: 'terms_and_conditions/{uuid-filename}',
    s3PathInstructorImage: 'instructors/images/{uuid-filename}',
    s3PathInstructorResume: 'instructors/resumes/{uuid-filename}',
    s3PathTestimonialImage: 'store-listing/testimonials/{uuid-filename}',
    s3PathThumbnail: 'preview-videos/{catalogueId}/{videoId}/thumbnail/',
    s3PathSyllabus: 'catalogues/syllabus/{uuid-filename}',
    s3PathStoreIcon: 'catalogues/store-icon/{uuid-filename}',
    s3PathQuestionPaper: 'catalogues/question-paper/{uuid-filename}',
    s3PathCatalogueImage: 'catalogues/images/{uuid-filename}',

    s3MaxKeys: 50,
    // Transcoding
    transcodingEnvironment: 'test',
    transcodingSourceS3: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    transcodingDestinationS3: 'deep-learn-vod-test-destination-1k6b102sisn5o',

    cloudFrontUrlCatalogueResource: 'https://media-ir-test.ace.online',
    s3ResourceUrl: 'https://{bucketName}.s3.ap-south-1.amazonaws.com/{path}',

    cloudFrontUrl: 'https://media-ir-test.ace.online',
    previewVideoCloudfrontUrl: 'https://cdn-vod.deep-learn.in',
    previewVideoHlsUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/index.m3u8',
    previewVideodashUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/manifest.mpd',

    cloudFrontUrlTnc: 'https://media-ir-test.ace.online',
    tncFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlInstructor: 'https://media-ir-test.ace.online',
    InstructorImageFileUrl: '{cloudFrontUrl}/{file-path}',
    InstructorResumeFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlTestimonial: 'https://media-ir-test.ace.online',
    TestimonialFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlThumbnail: 'https://d2gd7uae3xw47.cloudfront.net',
    thumbnailFolderUrl: '{cloudFrontUrl}/transcoding_version_3/preview-videos/{videoId}/thumbnails',

    cloudFrontUrlStoreIcon: 'https://media-ir-test.ace.online',
    syllabusFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrounUrlStoreIcon: 'https://media-ir-test.ace.online',
    storeIconFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlQuestionPaper: 'https://media-ir-test.ace.online',
    questionPaperFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlCatalogueImage: 'https://media-ir-test.ace.online',
    catalogueImageFileUrl: '{cloudFrontUrl}/{file-path}',
    /// Bulk upload students sample resource link
    bulkUploadStudentXlxSampleFileLink:
      'https://media-ir-test.ace.online/live-classes/bulk_upload_sample_template.xlsx',
  };
}

function buildDevEnvVars() {
  return {
    ENV: 'dev',

    rsaPublicKey:
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCA33d/ObvH5A+UkxrtoAI5MmC4R0saRRomrbnVPZj2oDSeCUgQL3WKDb/xxwbRVu+ZIcbLBWal3aoLH9W6TKTHbZY6czkTHaT1RzeWX7nWwiwuZOVIc7gdH6ty+u+p00XTI0Rnme7dNlRF/8f92JQ045sqqSxb78pOYzCQZFxdhQIDAQAB',
    hmacSecretKey: 'C6PqJwbyW4',
    s3BucketFileExplore: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketPublisher: 'deep-learn-internal-resources-test',
    s3BucketPreviewVideos: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketLegal: 'deep-learn-internal-resources-test',
    s3BucketInstructor: 'deep-learn-internal-resources-test',
    s3BucketThumbnail: 'deep-learn-vod-test-destination-1k6b102sisn5o',
    s3BucketTestimonial: 'deep-learn-internal-resources-test',
    s3BucketSyllabus: 'deep-learn-internal-resources-test',
    s3BucketStoreIcon: 'deep-learn-internal-resources-test',
    s3BucketQuestionPaper: 'deep-learn-internal-resources-test',
    s3BucketCatalogueImage: 'deep-learn-internal-resources-test',
    s3BucketLiveCLassResources: 'deep-learn-internal-resources-test',

    s3PathLiveClassNotes: 'live-classes/notes/',
    s3PathLiveClassAssignments: 'live-classes/assignments/',
    s3PathLiveClassPracticeTests: 'live-classes/practice-test/',
    s3PathLiveClassThumbnails: 'live-classes/thumbnails/{uuid-filename}',

    s3PathImage: '[module]/images/',
    s3PathResource: '[module]/resources/',
    s3PathPreviewVideos: 'preview-videos/[catalogueId]/',
    s3PathLegalFile: 'terms_and_conditions/{uuid-filename}',
    s3PathInstructorImage: 'instructors/images/{uuid-filename}',
    s3PathInstructorResume: 'instructors/resumes/{uuid-filename}',
    s3PathTestimonialImage: 'store-listing/testimonials/{uuid-filename}',
    s3PathThumbnail: 'preview-videos/{catalogueId}/{videoId}/thumbnail/',
    s3PathSyllabus: 'catalogues/syllabus/{uuid-filename}',
    s3PathStoreIcon: 'catalogues/storeIcon/{uuid-filename}',
    s3PathQuestionPaper: 'catalogues/question-paper/{uuid-filename}',
    s3PathCatalogueImage: 'catalogues/images/{uuid-filename}',

    s3MaxKeys: 50,
    // Transcoding
    transcodingEnvironment: 'development',
    transcodingSourceS3: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    transcodingDestinationS3: 'deep-learn-vod-test-destination-1k6b102sisn5o',

    cloudFrontUrlCatalogueResource: 'https://media-ir-test.ace.online',
    s3ResourceUrl: 'https://{bucketName}.s3.ap-south-1.amazonaws.com/{path}',

    cloudFrontUrl: 'https://media-ir-test.ace.online',
    previewVideoCloudfrontUrl: 'https://cdn-vod.deep-learn.in',
    previewVideoHlsUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/index.m3u8',
    previewVideodashUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/manifest.mpd',

    cloudFrontUrlTnc: 'https://media-ir-test.ace.online',
    tncFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlInstructor: 'https://media-ir-test.ace.online',
    InstructorImageFileUrl: '{cloudFrontUrl}/{file-path}',
    InstructorResumeFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlTestimonial: 'https://media-ir-test.ace.online',
    TestimonialFileUrl: '{cloudFrontUrl}/{file-path}',
    cloudFrontUrlThumbnail: 'https://d2gd7uae3xw47.cloudfront.net',
    thumbnailFolderUrl: '{cloudFrontUrl}/transcoding_version_3/preview-videos/{videoId}/thumbnails',

    cloudFrounUrlSyllabus: 'https://media-ir-test.ace.online',
    syllabusFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlStoreIcon: 'https://media-ir-test.ace.online',
    storeIconFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlQuestionPaper: 'https://media-ir-test.ace.online',
    questionPaperFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlCatalogueImage: 'https://media-ir-test.ace.online',
    catalogueImageFileUrl: '{cloudFrontUrl}/{file-path}',
    /// Bulk upload students sample resource link
    bulkUploadStudentXlxSampleFileLink:
      'https://media-ir-test.ace.online/live-classes/bulk_upload_sample_template.xlsx',
  };
}

export { getEnvVars };
